import * as React from 'react';
import { connect } from 'react-redux';
import { AdminOpenClose } from '../../components/pages/survey-admin/AdminOpenClose';
import { AudienceLoaderContainer } from '../../containers/pages/AudienceLoaderContainer';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/SurveyAdminStore';
import { EmailTemplateLoader } from '../loaders/EmailTemplateLoader';

export const AdminOpenCloseContainer = connect(
	(state: IApplicationState) => ({
		...state.surveyAdmin,
		...state.surveyAdmin.surveyAdminSummary,
		...state.emailTemplates,
		reminderEmails: state.emailTemplates.reminderEmails,
		loading: state.surveyAdmin.isLoadingAudiences,
	}),
	{ onChange: ActionCreators.HandleOpenCloseDatesChange, update: ActionCreators.UpdateAudience },
)(AdminOpenClose);

export class AdminOpenClosePage extends React.PureComponent<{ surveyId: number; audienceId: number }> {
	public render() {
		return (
			<>
				<AdminOpenCloseContainer audienceId={this.props.audienceId} />
				<AudienceLoaderContainer surveyId={this.props.surveyId} />
				<EmailTemplateLoader surveyId={this.props.surveyId} audienceId={this.props.audienceId} />
			</>
		);
	}
}
